module.exports = __webpack_public_path__ + "static/media/asteroid.53bb17a7.png";